import React, {useContext} from 'react';
import landingStyle from './style';
import BackgroundSlideshow from '../../components/backgroundSlideshow/index';
import {dskBgs, mobBgs} from './imageRoundUp';
import {GlobalContext} from '../../utilities/GlobalContext';
import Questionare from './questionare/index';

export default function Landing({slideTemplate}) {
	let isMobile = useContext(GlobalContext).isMobile;
	let style = landingStyle();
	let images = isMobile ? mobBgs : dskBgs;

	return (
		<BackgroundSlideshow images={images}>
			<div style={style.contentContainer()}>
				<Questionare slideTemplate={slideTemplate} />
			</div>
		</BackgroundSlideshow>
	);
}
